import { checkSession } from "@features/auth";
import { redirect } from "@tanstack/react-router";
import { fetchQuery, graphql } from "relay-runtime";
import type { AppRouterContext } from "~/router";
import type { accessOneDeliveryGateQuery } from "./__generated__/accessOneDeliveryGateQuery.graphql";

export const COMING_SOON_PATH = "/one-delivery/onboarding/coming-soon";

const accessQuery = graphql`
	query accessOneDeliveryGateQuery {
		onedeliveryAccess
	}
`;

/**
 * Route guard for the One Delivery beta: logged-in users without access (only Bace admins and
 * the beta users added in the admin dashboard have it) see the coming-soon page. Anonymous
 * users are left to the pages, which ask them to sign in.
 */
export async function requireOneDeliveryAccess(environment: AppRouterContext["relayEnvironment"]) {
	if (!(await checkSession())) return;
	const data = await fetchQuery<accessOneDeliveryGateQuery>(environment, accessQuery, {}, { fetchPolicy: "network-only" }).toPromise();
	if (!data?.onedeliveryAccess) throw redirect({ to: COMING_SOON_PATH });
}
